function a(o, r) {
  let t = o(),
    n = new Set();
  return {
    getSnapshot() {
      return t;
    },
    subscribe(e) {
      return n.add(e), () => n.delete(e);
    },
    dispatch(e) {
      for (var _len = arguments.length, s = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        s[_key - 1] = arguments[_key];
      }
      let i = r[e].call(t, ...s);
      i && (t = i, n.forEach(c => c()));
    }
  };
}
export { a as createStore };